import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AppConfigService} from "projects/nter-ui-kit/src/lib/framework/config/app-config.service";
import {
  RegisterUserRequest,
  UpdateUserContactRequest,
  User,
  UserRetailerRelationshipDto,
} from "projects/nter-ui-kit/src/lib/framework/security/model/user.model";
import {UserService} from "projects/nter-ui-kit/src/lib/framework/security/service/user.service";

@Injectable({
  providedIn: 'root',
})
export class ConsoleUserService extends UserService {
  private environment: any;

  constructor(http: HttpClient, config: AppConfigService) {
    super(http, config);
    this.environment = config.environment;
  }

  //TODO move this impl to each of the web apps
  public registerNewPortalUser(request: RegisterUserRequest): Observable<User> {
    const uri = this.baseRbacUrl + '/portal/register';
    return this.http.post<User>(uri, request, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: '*/*',
      }),
    });
  }

  public getUserRetailerRelationship(request: RegisterUserRequest): Observable<UserRetailerRelationshipDto> {
    const uri = this.baseRbacUrl + '/portal/details';
    return this.http.post<UserRetailerRelationshipDto>(uri, request, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: '*/*',
      }),
    })
  }

  public updateUserContactAndOtpPreferences(request: UpdateUserContactRequest): Observable<User> {
    const uri = this.baseRbacUrl + '/portal/communications';
    return this.http.post<User>(uri, request, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: '*/*',
      }),
    });
  }

  getAllowedLocationsForLandlord(landlordId: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.environment.apiSecurityHost}/console/rbac/user/landlord/${landlordId}/granted-locations`);
  }

  getUser(ownerUserId: number): Observable<User> {
    const uri = `${this.baseRbacUrl}/portal/${ownerUserId}`;
    return this.http.get<User>(uri);
  }
}
